// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import DebitItem from '@deere/cps-it.warranty-model-factory/lib/partial-debit';
import DebitLaborPanelRowBody from './debit-labor-panel-row-body';
import DebitLaborPanelRowHeader from './debit-labor-panel-row-header';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {buildNumber} from '../../../../shared/services/build-number';

function handleAdjustmentValueChange(itemNumber, serialNumber) {

    this.actions.updateAdjustmentValue(itemNumber, serialNumber);

}

function handleAdjustmentTypeChange(itemNumber, type) {

    this.actions.updateAdjustmentType(itemNumber, type, this.adjustmentTypes);

}

const DebitLaborPanel = props =>
    props.labors.length > 0 &&
        <section className='debit-labor-panel'>
            <header className='debit-labor-panel-title'>
                <FormattedMessage
                    id='LABOR_WITH_COUNT'
                    values={{
                        count: buildNumber(props.labors.length)
                    }}
                />
            </header>
            <DebitLaborPanelRowHeader/>
            <section className='labor-list'>
                {props.labors.map((labor, index) =>
                    <DebitLaborPanelRowBody
                        adjustmentTypes={props.adjustmentTypes}
                        isEditable={props.isEditable}
                        key={index}
                        labor={labor}
                        onAdjustmentTypeChange={handleAdjustmentTypeChange.bind(props, labor.itemNumber)}
                        onAdjustmentValueChange={handleAdjustmentValueChange.bind(props, labor.itemNumber)}
                    />
                )}
            </section>
        </section>;

DebitLaborPanel.displayName = 'DebitLaborPanel';
DebitLaborPanel.propTypes = {
    actions: PropTypes.object,
    adjustmentTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)),
    isEditable: PropTypes.bool.isRequired,
    labors: PropTypes.arrayOf(PropTypes.instanceOf(DebitItem)).isRequired
};

export default DebitLaborPanel;



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/debit-labor-panel/debit-labor-panel.js